import React from 'react';
import { Button } from './ui/Button';
import { Check, Clock, Shield } from 'lucide-react';
export function OfferSection() {
  const bullets = ['Guía digital completa', 'Checklist de mochila sensorial', 'Plan de acción de 60 segundos', 'Diario de disparadores', 'Tarjeta visual imprimible'];
  return <section id="oferta-final" className="bg-white pt-12 pb-8 md:pt-20 md:pb-12 px-5 scroll-mt-8" data-id="element-126">
      <div className="max-w-3xl mx-auto" data-id="element-127">
        <div className="text-center mb-8" data-id="element-128">
          <h2 className="text-2xl md:text-4xl font-bold text-[#2D1F0E] mb-4 leading-snug" data-id="element-129">
            Empieza hoy con una respuesta clara para la próxima crisis
          </h2>
          <p className="text-[1.05rem] md:text-lg text-[#6B5D4F] max-w-2xl mx-auto leading-relaxed" data-id="element-130">
            Accede al Protocolo SOS y ten a la mano una forma más calmada, clara
            y útil de responder cuando tu hijo colapsa.
          </p>
        </div>

        {/* Risk reduction / micro-guarantee */}
        <div className="text-center mb-10" data-id="element-131">
          <p className="text-base md:text-lg text-[#4A6741] leading-relaxed max-w-lg mx-auto italic font-medium" data-id="element-132">
            Hecho para ayudarte en el momento real, no para darte más teoría.
          </p>
        </div>

        <div className="bg-[#FDF8F0] rounded-[2rem] p-6 md:p-12 border-2 border-[#D4A853]/30 shadow-xl relative" data-id="element-133">
          {/* Badge */}
          <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#C75C3A] text-white px-6 py-1.5 rounded-full text-xs md:text-sm font-bold tracking-wide shadow-md whitespace-nowrap" data-id="element-134">
            PRECIO BETA DE LANZAMIENTO
          </div>

          <div className="text-center space-y-8 mt-4" data-id="element-135">
            {/* Price block */}
            <div className="py-6 flex flex-col items-center justify-center bg-white rounded-2xl border border-[#D4A853]/20 mx-auto max-w-sm" data-id="element-136">
              <div className="text-[#6B5D4F] text-sm md:text-base line-through mb-1" data-id="element-137">
                Precio Regular: $12.99
              </div>
              <div className="flex items-start justify-center text-[#C75C3A]" data-id="element-138">
                <span className="text-3xl font-bold mt-1" data-id="element-139">$</span>
                <span className="text-6xl md:text-7xl font-black tracking-tighter" data-id="element-140">
                  6.49
                </span>
              </div>
              <div className="text-[#4A6741] text-sm font-medium mt-3 bg-[#F0F4EC] px-3 py-1 rounded-full" data-id="element-141">
                Pago único • Acceso inmediato • Material en español
              </div>
            </div>

            {/* Urgency */}
            <div className="flex items-center justify-center gap-2 text-[#C75C3A] font-medium text-sm md:text-base bg-[#C75C3A]/10 py-2 px-4 rounded-full w-fit mx-auto" data-id="element-142">
              <Clock className="w-4 h-4" data-id="element-143" />
              <span data-id="element-144">Disponible por tiempo limitado</span>
            </div>

            {/* Bullets */}
            <div className="text-left max-w-sm mx-auto space-y-3" data-id="element-145">
              {bullets.map((bullet, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-146">
                  <Check className="w-5 h-5 text-[#4A6741] flex-shrink-0" data-id="element-147" />
                  <span className="text-[#2D1F0E] font-medium text-[0.9rem] md:text-base" data-id="element-148">
                    {bullet}
                  </span>
                </div>)}
            </div>

            {/* Emotional close */}
            <p className="text-[0.95rem] md:text-base text-[#2D1F0E] font-medium leading-relaxed" data-id="element-149">
              Tenlo listo hoy para no volver a improvisar en plena crisis.
            </p>

            {/* CTA */}
            <div id="offer-cta" className="pt-2 space-y-4 scroll-mt-16" data-id="element-150">
              <Button fullWidth href="https://www.upreferr.com/cart/44203439128711:1" className="text-xl md:text-2xl py-6 min-h-[64px] shadow-xl" onClick={() => {
              if (typeof window !== 'undefined' && window.fbq) {
                window.fbq('track', 'InitiateCheckout', {
                  content_name: 'Protocolo SOS',
                  content_ids: ['44203439128711'],
                  content_type: 'product',
                  value: 6.49,
                  currency: 'USD',
                  num_items: 1
                });
              }
            }} data-id="element-151">
                Quiero saber qué hacer
              </Button>

              {/* Trust lines below CTA */}
              <div className="flex items-center justify-center gap-2 text-sm md:text-base text-[#6B5D4F] font-medium" data-id="element-152">
                <Shield className="w-4 h-4" data-id="element-153" />
                <span data-id="element-154">Pago seguro con tarjeta o Shop Pay</span>
              </div>
              <p className="text-xs md:text-sm text-[#6B5D4F]/70 text-center" data-id="element-155">
                Si tienes algún problema con el acceso, puedes escribirnos.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}